import { MINUTES_IN_HOUR, SECONDS_IN_MINUTE } from '../../utils/dateUtil';
import { useSiteIntAttributes } from '../useAttribute';
import { STAFF_OPEN_HOUR_IN_SECONDS } from '../../configs/siteAndTrustAttributes';
import { errorToast } from '../../utils/toast';
import { useMemo } from 'react';

export const useSiteStartingMinutesWithinHour = ({
  apptsLengthInMinutes,
}: {
  apptsLengthInMinutes: number;
}) => {
  const [siteOpenInSecondsOfDay] = useSiteIntAttributes(
    STAFF_OPEN_HOUR_IN_SECONDS,
  );

  return useMemo(() => {
    if (!siteOpenInSecondsOfDay) {
      errorToast("Site's opening hour is not configured properly.");
      return [];
    }
    const offsetsArray = [];
    const startingHourOffset =
      (siteOpenInSecondsOfDay / SECONDS_IN_MINUTE) % MINUTES_IN_HOUR;
    let firstOffsetInHour = startingHourOffset % apptsLengthInMinutes;
    while (firstOffsetInHour < MINUTES_IN_HOUR) {
      offsetsArray.push(firstOffsetInHour);
      firstOffsetInHour += apptsLengthInMinutes;
    }
    return offsetsArray;
  }, [siteOpenInSecondsOfDay, apptsLengthInMinutes]);
};
